import { Box, Typography, styled } from '@mui/material'
import React, { PropsWithChildren } from 'react'

interface NotFoundProps {
    type?: 'order' | 'seller' | 'stopEvent'
}

const NotFound = ({ children, type = 'order' }: PropsWithChildren<NotFoundProps>) => {
    return (
        <RootStyled>
            { type === 'order' ? (
                <NotFoundText>¡En este momento su pedido no tiene ninguna novedad!</NotFoundText>
            ) : (type === 'seller') ? (
                <NotFoundText>No se encontraron resultados</NotFoundText>
            ) : (type === 'stopEvent') ? (
                children
            ) : (
                <NotFoundText>Error desconocido</NotFoundText>
            )}
        </RootStyled>
    )
}

const NotFoundData = ({ children }: React.PropsWithChildren) => {
    return (
        <RootStyled>
            <Typography color="primary" align="center" variant="h6" component="h1" lineHeight="1.2" fontWeight={400}>
                {children}
            </Typography>
        </RootStyled>
    )
}

const NotFoundText = ({ children }: React.PropsWithChildren) => {
    return (
        <Typography color="primary" align="center" variant="h6" component="h1" lineHeight="1.2" fontWeight={400}>
            {children}
        </Typography>
    )
}

const RootStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
}))

export default NotFound
export { NotFoundData }
